// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___ec9828fc29fdaebf4e6","cls2":"ImpactHubProfileCard-cls2__c7cec07ce842493b2055 ImpactHubProfileCard-cls1___ec9828fc29fdaebf4e6"};